import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { setSwitcherValue } from '../actions/switchers';
import SwitcherButton from '../components/SwitcherButton';
export class Switcher extends PureComponent {
    constructor(props) {
        super(props);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.render = this.render.bind(this);
    }

    componentWillMount() {
        const config = this.props.config;
        this.props.setSwitcherValue(config.name, config.value);
    }

    onButtonClick(value) {
        this.props.setSwitcherValue(this.props.config.name, value);
        this.props.onButtonClick(value);
    }

    render() {
        const {
          config: { items },
          switcher,
          displayType,
    } = this.props;

        return (
          <form
              onSubmit={this.onButtonClick}
              className={`ui-switcher${displayType === 'radio' ? '__radio' : ''}`}
          >
            {items.map((item) => (
                <SwitcherButton
                    key={item.caption}
                    isSelected={!!switcher && item.value === switcher.get('value')}
                    label={item.caption}
                    labelResponsive={item.captionResponsive}
                    value={item.value}
                    onClick={this.onButtonClick}
                    iconName={item.iconName || null}
                    className={item.className || null}
                    displayType={displayType}
                  />
            ))}
          </form>
        );
    }
}

/* eslint consistent-return: 0*/
Switcher.propTypes = {
    config: PropTypes.shape({
        items: PropTypes.arrayOf(
      PropTypes.shape({
          caption: PropTypes.string,
          value: PropTypes.string,
      })
    ),
        value: PropTypes.string,
        name: PropTypes.string,
    }),
    onButtonClick: PropTypes.func.isRequired,
    setSwitcherValue: PropTypes.func,
    switcher: (props, propName, componentName) => {
        const propValue = props[propName];
        if (propValue && !Map.isMap(propValue)) {
            return new Error(
        `Invalid prop ${propName} supplied to ${componentName}. ${propName} must be a Map.`
      );
        }
    },
};
function mapStateToProps(state, ownProps) {
    return {
        switcher: state.switchers.get(ownProps.config.name),
    };
}

const mapDispatchToProps = (dispatch) => ({
    setSwitcherValue: (name, value) => {
        dispatch(setSwitcherValue(name, value));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Switcher);



// WEBPACK FOOTER //
// ./src/client/containers/Switcher.js